import { AdminLayout, useTranslation } from "@opendash/core";
import { useUIPermission } from "@opendash/plugin-parse";
import { AdminToolbar } from "@opendash/ui";
import { Button, Flex, Select, Typography } from "antd";
import { observer } from "mobx-react-lite";
import React, { useMemo, useState } from "react";
import {
  KanbanContextProvider,
  KanbanManager,
  TicketSaveModal,
  ViewSelect,
} from "../../features/tickets";
import { Kanban_State } from "../../js/parsegenerated";
import { OpenService } from "../../types/config";

export const MonitorPage = observer(() => {
  const t = useTranslation();
  const [kanbanState, setKanbanState] = useState<Kanban_State>(undefined);
  const [ticketSaveModalOpen, setTicketSaveModalOpen] = useState(false);

  const kanbanManager = useMemo(
    () =>
      new KanbanManager({
        defaultView: "state",
        viewtype: "list",
        lskey: "monitor",
      }),
    []
  );

  const canCreateTicket = useUIPermission([
    OpenService.Permissions.Create.ticket,
  ]);
  const canChangeView = useUIPermission([
    OpenService.Permissions.Update.kanban_view,
  ]);

  function openSaveModal(flag: boolean, state?: Kanban_State) {
    setTicketSaveModalOpen(flag);
    setKanbanState(state);
  }

  return (
    <AdminLayout contentPadding>
      <AdminToolbar
        title={t("maintenance:monitor.view.headline")}
        actions={
          <Flex gap="8px" vertical justify="flex-end">
            <Flex gap="8px" align="center">
              <Typography.Text>
                {t("maintenance:monitor.emptycolumns.label", {
                  view:
                    kanbanManager.viewType === "column"
                      ? t("maintenance:ticket.overview.columnView")
                      : t("maintenance:ticket.overview.listView"),
                })}
                :
              </Typography.Text>
              <Select
                key={0}
                value={kanbanManager.hideEmpty}
                onChange={(value) => {
                  kanbanManager.setHideEmptyColumns(value);
                }}
                style={{ width: 100 }}
                options={[
                  {
                    label: t("maintenance:global.yes"),
                    value: false,
                  },
                  {
                    label: t("maintenance:global.no"),
                    value: true,
                  },
                ]}
              />
              <Typography.Text>
                {t("maintenance:monitor.view.label")}:
              </Typography.Text>
              <Select
                key={1}
                value={kanbanManager.viewType}
                onChange={(value) => {
                  kanbanManager.setViewType(value);
                }}
                style={{ width: 100 }}
                options={[
                  {
                    label: t("maintenance:ticket.overview.columnView"),
                    value: "column",
                  },
                  {
                    label: t("maintenance:ticket.overview.listView"),
                    value: "list",
                  },
                ]}
              />

              {canChangeView && (
                <>
                  <Typography.Text>
                    {t("maintenance:monitor.viewgrouping.label")}:
                  </Typography.Text>
                  <ViewSelect
                    key={2}
                    value={kanbanManager.grouping}
                    onChange={(val) => {
                      kanbanManager.setGrouping(val);
                    }}
                  />
                </>
              )}
              {canCreateTicket && (
                <Button key={3} onClick={() => openSaveModal(true)}>
                  {t("maintenance:menu.tickets.create_label")}
                </Button>
              )}
            </Flex>
          </Flex>
        }
      />
      <KanbanContextProvider value={kanbanManager}>
        {kanbanManager.getViewComponent()}
      </KanbanContextProvider>

      <TicketSaveModal
        open={ticketSaveModalOpen}
        onClose={() => openSaveModal(false)}
        initialValues={{
          state: kanbanState?.id,
        }}
        onSaveSuccess={() => kanbanManager.reload()}
      />
    </AdminLayout>
  );
});
